import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ItemBox from '../../components/shared/item_box';
import ListaContratos from '../../components/contratos/chamamento';


function ListaContratosScreen() {
    return (
        <Fragment>
            <Head titulo="Todos contratos de Chamanentos do Município de Macuco" />
            <Header />
            <Container>
                <Fragment>
                    <ItemBox
                        titulo={"Nova Lei de Licitações"}
                        texto={<Fragment><p>Confira no link abaixo as minutas, documentos padrões e legislação referente à Nova Lei de Licitações no Município de Macuco</p><br /></Fragment>}
                        link={"https://prefeituramacuco.rj.gov.br/site/transparencia-e-acesso-a-informacao/legislacao-e-minutas-nova-lei-de-licitacoes-e-contratos.html"}
                    />
                    <br />
                    <ItemBox
                        titulo={"Fiscais de Contratos"}
                        texto={<Fragment><p>Clique aqui e veja a listagem de servidores municipais responsáveis pela fiscalização dos contratos firmados por essa prefeitura.</p><br /></Fragment>}
                        link={"contratos/fiscais"}
                    />
                    <br />
                </Fragment>
                <ListaContratos />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListaContratosScreen;